module.exports = __webpack_public_path__ + "static/media/img3-2.d5eb2fb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/aguacate/biosense/diff/img3-2.png
// module id = 1071
// module chunks = 3